import { defineStore } from 'pinia';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { getFeatureData } from 'config-request';
import { useFeatureListStore } from './feature-list';
import { useGlobalStore } from './global';
export const useCarVersionStore = defineStore('car-version', {
    state() {
        return {
            preGenerationInfo: null,
        };
    },
    getters: {
        getTotalGeneration() {
            const featureList = useFeatureListStore();
            return featureList.data?.generation_map
                ? Object.keys(featureList.data?.generation_map).length
                : 0;
        },
        getPreGenerationInfo(info) {
            return this.preGenerationInfo;
        },
        getYearsList() {
            const featureList = useFeatureListStore();
            if (!featureList.data)
                return [];
            const codeList = [
                CategoryCode.VersionBattery,
                SubCategoryCode.Version,
                FeatureType.Version,
            ];
            const featureItem = getFeatureData(codeList, featureList.data);
            return featureItem?.year_list ?? [];
        },
        descList() {
            const featureList = useFeatureListStore();
            const global = useGlobalStore();
            return (featureList.data?.generation_map[global.currentOptions.generation_code]
                ?.desc_list ?? []);
        },
        currentGeneration() {
            const featureList = useFeatureListStore();
            const global = useGlobalStore();
            return featureList.data?.generation_map[global.currentOptions.generation_code];
        },
        getYearGenerationList() {
            const featureList = useFeatureListStore();
            if (!featureList.data)
                return [];
            const codeList = [
                CategoryCode.VersionBattery,
                SubCategoryCode.Version,
                FeatureType.Version,
            ];
            const featureItem = getFeatureData(codeList, featureList.data);
            if (featureItem) {
                return featureItem?.year_list?.map((item) => {
                    return {
                        subList: item?.generation_code_list.map((option) => featureList.data?.generation_map[option]),
                        ...item,
                    };
                });
            }
            return [];
        },
        generationList() {
            const featureList = useFeatureListStore();
            if (!featureList.data)
                return [];
            const codeList = [
                CategoryCode.VersionBattery,
                SubCategoryCode.Version,
                FeatureType.Version,
            ];
            const featureItem = getFeatureData(codeList, featureList.data);
            if (featureItem) {
                return featureItem?.year_list
                    ?.find((item) => {
                    if (item?.selected === 1) {
                        return true;
                    }
                    // return   featureList.data?.generation_map[option]
                })
                    ?.generation_code_list.map((option) => featureList.data?.generation_map[option]);
                // return featureItem.option_list?.map(
                //   (option) => featureList.data?.generation_map[option]
                // )
            }
            return [];
        },
    },
    actions: {
        setPreGenerationInfo(info) {
            this.preGenerationInfo = info;
        },
    },
});
